export interface User {
  sub?: string
  given_name: string
  family_name: string
  email: string
  role?: string
  domains?: string[]
}

export interface Site {
  id?: number
  name: string
  domain: string
  image?: string | null
  title_regexp?: string
  title_replacement?: string
  body_regexp?: string
  body_replacement?: string
  append_parameter?: string
}

export interface TokenSummery {
  date: number
  total: number
  increase: number
  decrease: number
}

export enum NotificationStatus {
  UNDELIVERED = "UNDELIVERED",
  DELIVERED   = "DELIVERED",
  CANCELED    = "CANCELED"
}

export interface Notification {
  id?: number
  site_id: number
  status?: NotificationStatus
  title: string
  body: string
  url: string
  image?: string
  reserve_at: string
  send_count?: number
  distribute_count?: number
  open_count?: number
  created_user_id?: string
  last_modified_user_id?: string | null
  created_user?: User
}

export interface DebugNotification {
  token: string
  domain: string
  title: string
  body: string
  url: string
  image?: string
}

export interface NotificationSummary {
  id?: number
  site_id: number
  title: string
  reserve_at: string
  send_count?: number
  distribute_count?: number
  open_count?: number
  ctr?: number
}

export enum FlushMessageType {
  SUCCESS = "SUCCESS",
  ERROR   = "ERROR",
  NOTICE  = "NOTICE",
  INFO    = "INFO"
}

export interface FlushMessage {
  id?: string
  type: FlushMessageType
  message: string
  life_time?: number
}
